import { useState } from "react";
import { ArrowUpRight, X } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ConsultModal = ({ onClose }) => {
  const submit = async (event) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    try {
      const response = await fetch(`${API}/consultations`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: form.get("name"), email: form.get("email"), interest: form.get("interest"), message: form.get("message") }),
      });
      if (!response.ok) throw new Error("Unable to save enquiry");
      onClose();
      toast.success("Your private consultation request is now with the BRK team.");
    } catch {
      toast.error("We could not send your request. Please try again.");
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="consult-modal" onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true" data-testid="consultation-modal">
        <button className="modal-close" onClick={onClose} aria-label="Close consultation form" data-testid="close-consultation-modal"><X /></button>
        <p className="eyebrow">PRIVATE CONSULTATION</p>
        <h2>Let’s talk<br /><em>property.</em></h2>
        <p>Tell us a little about what you are looking for. The right person from our team will be in touch within one working day.</p>
        <form onSubmit={submit}>
          <input name="name" required placeholder="Your name" aria-label="Your name" data-testid="consultation-name" />
          <input name="email" required type="email" placeholder="Email address" aria-label="Email address" data-testid="consultation-email" />
          <select name="interest" defaultValue="" aria-label="How can we help" data-testid="consultation-interest" required>
            <option value="" disabled>How can we help?</option>
            <option>Find a property</option>
            <option>Build a portfolio</option>
            <option>Sell a property</option>
          </select>
          <textarea name="message" placeholder="Anything else we should know?" aria-label="Additional message" data-testid="consultation-message" />
          <button className="gold-btn" type="submit" data-testid="submit-consultation">Request a conversation <ArrowUpRight size={16} /></button>
        </form>
      </div>
    </div>
  );
};

export const CalculatorModal = ({ onClose, onConsult }) => {
  const [budget, setBudget] = useState(5000000);
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="consult-modal calculator-modal" onClick={(event) => event.stopPropagation()} role="dialog" data-testid="calculator-modal">
        <button className="modal-close" onClick={onClose} aria-label="Close calculator" data-testid="close-calculator-modal"><X /></button>
        <p className="eyebrow">INVESTMENT LENS</p>
        <h2>See the<br /><em>possibility.</em></h2>
        <p>Explore an indicative annual return based on your intended investment.</p>
        <label htmlFor="budget-slider">Investment amount <strong>AED {budget.toLocaleString()}</strong></label>
        <input id="budget-slider" type="range" min="1000000" max="15000000" step="250000" value={budget} onChange={(event) => setBudget(Number(event.target.value))} data-testid="investment-slider" />
        <div className="return-result">
          <span>Indicative annual return</span>
          <strong>AED {(budget * 0.072).toLocaleString(undefined, { maximumFractionDigits: 0 })}</strong>
          <small>Based on a 7.2% blended estimate</small>
        </div>
        <button className="gold-btn" onClick={onConsult} data-testid="calculator-consultation-button">Discuss your strategy <ArrowUpRight size={16} /></button>
      </div>
    </div>
  );
};

export const ShortlistModal = ({ shortlist, onClose, onOpenProperty, onRemove, onConsult }) => (
  <div className="modal-backdrop" onClick={onClose}>
    <div className="consult-modal shortlist-modal" onClick={(event) => event.stopPropagation()} role="dialog" data-testid="shortlist-modal">
      <button className="modal-close" onClick={onClose} aria-label="Close shortlist" data-testid="close-shortlist-modal"><X /></button>
      <p className="eyebrow">YOUR PRIVATE SHORTLIST</p>
      <h2>Places worth<br /><em>returning to.</em></h2>
      {shortlist.length === 0 ? (
        <p data-testid="shortlist-empty">Your shortlist is empty. Save a property to keep it close.</p>
      ) : (
        <div className="shortlist-items">
          {shortlist.map((property) => (
            <div className="shortlist-row" key={property.id}>
              <button className="shortlist-open" onClick={() => onOpenProperty(property)} data-testid={`shortlist-item-${property.id}`}>
                <img src={property.image} alt="" />
                <span>{property.name}<small>{property.location}</small></span>
                <ArrowUpRight size={16} />
              </button>
              <button className="shortlist-remove" onClick={() => onRemove(property.id)} aria-label={`Remove ${property.name}`} data-testid={`shortlist-remove-${property.id}`}><X size={14} /></button>
            </div>
          ))}
        </div>
      )}
      <button className="gold-btn" onClick={onConsult} data-testid="shortlist-consultation-button">Talk through my shortlist <ArrowUpRight size={16} /></button>
    </div>
  </div>
);
